import ReactIs from 'react-is';
const isValidChild = (child) => ReactIs.isElement(child) || ReactIs.isFragment(child) || ReactIs.isPortal(child);
export const reactChildrenValidator = (value, logger, logLabel) => {
    const valid = Array.isArray(value) ? value.some(child => isValidChild(child)) : isValidChild(value);
    if (!valid) {
        logger(`${logLabel} must be provided. This component requires children to render any UI.`);
    }
    return valid;
};
//# sourceMappingURL=react-children.js.map